<template>
  <RouterLink
    class="nav-tile m-reset-link"
    :class="{
      '-primary': primary,
    }"
    :to="to"
  >
    <div class="nav-tile-inside">
      <BaseIcon
        :icon="icon"
      />
      <div
        class="nav-tile-label"
        v-html="label"
      />
    </div>
  </RouterLink>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: null,
  },
  primary: {
    type: Boolean,
    default: false,
  },
  to: {
    type: [Object, String],
    default: null,
  },
});
</script>

<style scoped>
.nav-tile {
  display: block;
  border-radius: var(--border-radius);
  border: var(--simple-border);
  color: var(--gray-900);
  cursor: pointer;

  background-color: var(--blue-5);
  &:hover {
    background-color: var(--elevated);
    border-color: var(--gray-300);
  }
  &.-primary {
    border-color: var(--blue);
    box-shadow: 0 0 0 1px var(--blue);
  }
}

.nav-tile-inside {
  padding: 16px;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 10px;
}

.nav-tile-label {
  font-weight: 700;
}
</style>
